import StocktakeItemsProductListPanel from "./stocktakeItemsProductListPanel.container";
export default StocktakeItemsProductListPanel;
